import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import React from 'react';
import spinningLogo from './spinningLogo.png';
import styles from './SpinningLoader.module.css';
export function SpinningLoader() {
  return React.createElement("img", {
    src: spinningLogo,
    className: styles.spinningImg
  }, null);
}